import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = ({ size = 40, color = '#244A95', text = null }) => {
  return (
    <div className="loading-spinner-container">
      <svg
        className="loading-spinner-svg"
        width={size}
        height={size}
        viewBox="0 0 50 50"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          className="loading-spinner-circle"
          cx="25"
          cy="25"
          r="20"
          fill="none"
          stroke={color}
          strokeWidth="4"
          strokeLinecap="round"
        />
      </svg>
      {text && <p className="loading-spinner-text">{text}</p>}
    </div>
  );
};

export default LoadingSpinner;
